// extracted by mini-css-extract-plugin
export default {"container":"ImageZoom_container__Ot1il","zoom":"ImageZoom_zoom__uSrCT","zoomIcon":"ImageZoom_zoomIcon__Cva6a","closeIcon":"ImageZoom_closeIcon__zdC2+"};